/**
 * Bonus Multiview View
 */

define(function(require) {
    'use strict';

    const i18n = require('i18n');
    const dompurify = require('dompurify');
    const dispatcher = require('bundle').dispatcher;
    const BonusMultiviewView = require('portlets/bonus-multiview/bonusmultiview.view');
    const BonusMultiviewCollection = require('portlets/bonus-multiview/bonusmultiview.bonus.collection');

    // todo: Refactor (rewrite to not use collection)
    return BonusMultiviewView.extend({

        initialize: function() {
            this.options = this.model.toJSON();
            this.collection = new BonusMultiviewCollection(null, { showAll: true });
            this.collection.bonusCode = this.model.get('config').bonusId;
            this.state = this.collection.fetch({ bonusIds: [this.collection.bonusCode] });
        },

        subscribe: function() {
            this.listenTo(this.collection, 'change', this.onChange);
        },

        portletDidMount: function() {
            this.state.done(() => {
                let bonus = this.collection.get(this.collection.bonusCode);

                if (!bonus) {
                    dispatcher.dispatch('bonusmultiview:bonus-details:popup:close');

                    return;
                }

                bonus = bonus.toJSON();

                this.fillBonusDetailsPopupTitle(bonus);
                this.$el.html(this.tmpl('bonus-multiview.detailedview', bonus));
                this.handleLoadingWebContent(bonus);
            }).fail(() => this.renderNetworkError());
        },

        fillBonusDetailsPopupTitle: function(bonus) {
            const $popupTitle = this.$el[0].closest('.fn-bonus-details-popup')?.querySelector('.popup-modal__title');

            if ($popupTitle) {
                $popupTitle.innerHTML = bonus.title || dompurify.sanitize(i18n.t(`playtech.mobile.system.bonus.${bonus.bonusCode}`));
            }
        },

        handleLoadingWebContent: function(bonus) {
            const $webcontentContainer = this.$('.fn-webcontent-container');
            const errorMessage = this.translate('playtech.mobile.system.descriptionError');

            this.loadContent(bonus.detailedViewWebContentId)
                .done(article => $webcontentContainer.html(this.parseReplacers(article) || errorMessage))
                .fail(() => $webcontentContainer.html(errorMessage));
        }
    });
});
